import type { Except } from "type-fest";
import { z } from "zod";

import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import type {
    ContentBlockId} from "./content-block-id";
import {
    contentBlockIdFactory,
    contentBlockIdZodSchema,
} from "./content-block-id";

type ContentBlock = {
    readonly _id: ContentBlockId;
    readonly _type: "CONTENT_BLOCK";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly title: Translatable;
    readonly content: Translatable;
    readonly link?: Translatable;
};

type FactoryParams = Except<ContentBlock, "_id" | "_type" | "_createdAt">;

const contentBlockFactory = (params: FactoryParams): ContentBlock => {
    return {
        ...params,
        _id: contentBlockIdFactory(),
        _type: "CONTENT_BLOCK",
        _createdAt: nowIsoAndUnix(),
    };
};

const contentBlockZodSchema: z.ZodSchema<ContentBlock> = z.object({
    _id: contentBlockIdZodSchema,
    _type: z.literal("CONTENT_BLOCK"),
    _createdAt: isoAndUnixZodSchema,
    title: translatableZodSchema,
    content: translatableZodSchema,
    link: translatableZodSchema.optional(),
});
export { contentBlockFactory, contentBlockZodSchema };
export type { ContentBlock };
